import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'

import connect from 'src/redux/connect'
import { resetAppMessage } from 'src/redux/actions/messages'

import styles from './message.module.scss'

type MessageProps = {
  message?: any
  resetAppMessage?: any
}

const Message: React.FC<MessageProps> = props => {
  const { message, resetAppMessage } = props
  const error = message?.type === 'error'
  return (
    <Snackbar
      open={!!message.text}
      message={message.text ?? ''}
      autoHideDuration={message.timeout}
      onClose={resetAppMessage}
      style={{ backgroundColor: 'none' }}
      ContentProps={{
        style: {
          fontSize: error ? '1.8rem' : '1.47rem',
          fontWeight: error ? 'bold' : 500,
          color: '#fff',
          letterSpacing: '1px',
          textAlign: 'center',
          flexGrow: 'unset',
        } as React.CSSProperties,
      }}
      className={`${styles.snackBar}${error ? ` ${styles.error}` : ''}`}
    />
  )
}

export default connect(
  ({ messages: { message } }) => ({
    message,
  }),
  { resetAppMessage },
)(Message)
